// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"421":"b3a50191","702":"b3a50191"}[chunkId] + ".chunk.css";
};